/**
 * Created by Olga Eremina on 19.10.2026
 */

const RemoveHintView = function () {
    this.hintFinger = undefined;
    this.tutorialMode = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("remove", this.show.bind(this));
};

RemoveHintView.prototype.show = function (move, inTutorial) {
    if (!inTutorial && this.tutorialMode) {
        return;
    }
    this.hide(inTutorial);

    if (!move.target.parent) {
        return;
    }

    this.hintFinger = FingerView.hintTap(move.target, {
        delay: move.delay / 1000,
        repeatDelay: move.interval / 1000
    });
};

RemoveHintView.prototype.hide = function (inTutorial) {
    if (!inTutorial && this.tutorialMode) {
        return;
    }
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;
};

RemoveHintView.prototype.setTutorialMode = function (tutorialMode) {
    this.tutorialMode = tutorialMode;
};
